import { environment } from '@environments/environment';

export const CR_WEB_API = {
  PERMISSIONS: '/api/permissions',
  ROLES: '/api/roles',
  ROLE_BY_NAME: (roleName: string) => `/api/roles/${encodeURIComponent(roleName)}`,
  ROLE_PERMISSIONS: (roleName: string) => `/api/roles/${encodeURIComponent(roleName)}/permissions`,
} as const;

export function crWebApiUrl(path: string): string {
  return `${environment.crApiUrl}${path}`;
}
